/* Embertine Kopf: Quiz-Overlay (iframe auf /pages/quiz?overlay=1), Länderliste, Zwei-Schritt-Formulare (Kündigung, Widerruf). */
(function () {
  'use strict';
  var html = document.documentElement;
  var inOverlay = html.classList.contains('eb-in-ov');

  /* ---------- Innerhalb des Overlays: Links öffnen in der Hauptseite ---------- */
  if (inOverlay) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || a.target || e.defaultPrevented) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(javascript|mailto|tel):/i.test(href)) return;
      e.preventDefault();
      try { window.top.location.href = a.href; } catch (err) { location.href = a.href; }
    });
    return;
  }

  /* ---------- Quiz-Overlay ---------- */
  var ov = document.querySelector('[data-eb-quiz-ov]');
  var lastFocus = null, frame = null, loadedSrc = '';
  function onQuizPage() { return /\/pages\/quiz\/?$/.test(location.pathname); }
  function buildSrc(preset) {
    var u = new URL(ov.getAttribute('data-src'), location.href);
    var q = new URLSearchParams();
    if (preset && preset.indexOf(':') > 0) { var p = preset.split(':'); q.set(p[0], p[1]); }
    u.searchParams.forEach(function (v, k) { if (k !== 'overlay') q.set(k, v); });
    q.set('overlay', '1'); /* nach dem Preset, weil die Quizseite den ersten Parameter als Preset liest */
    u.search = q.toString();
    return u.pathname + u.search;
  }
  function openQuiz(preset) {
    if (!ov) return false;
    var src = buildSrc(preset);
    if (!frame) {
      frame = document.createElement('iframe');
      frame.className = 'eb-quiz-ov-frame';
      frame.title = 'Find your moment: the ritual quiz';
      frame.setAttribute('allow', 'clipboard-write');
      frame.addEventListener('load', function () { ov.classList.add('is-loaded'); });
      ov.appendChild(frame);
    }
    if (src !== loadedSrc) { ov.classList.remove('is-loaded'); frame.src = src; loadedSrc = src; }
    lastFocus = document.activeElement;
    ov.hidden = false;
    ov.setAttribute('aria-hidden', 'false');
    html.classList.add('eb-lock');
    requestAnimationFrame(function () { ov.classList.add('is-open'); });
    var x = ov.querySelector('[data-eb-quiz-close]'); if (x) x.focus();
    return true;
  }
  function closeQuiz() {
    if (!ov || ov.hidden) return;
    ov.classList.remove('is-open');
    ov.setAttribute('aria-hidden', 'true');
    html.classList.remove('eb-lock');
    setTimeout(function () { if (!ov.classList.contains('is-open')) ov.hidden = true; }, 500);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    refreshCount();
  }
  function refreshCount() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var bag = document.querySelector('.eb-header a[href$="/cart"]'); if (!bag) return;
      var n = bag.querySelector('.eb-count');
      if (c.item_count > 0) {
        if (!n) { n = document.createElement('span'); n.className = 'eb-count'; bag.appendChild(n); }
        n.textContent = c.item_count;
      } else if (n) { n.remove(); }
      bag.setAttribute('aria-label', 'Bag, ' + c.item_count + ' items');
    }).catch(function () {});
  }
  if (ov) {
    /* Fangphase: greift vor dem Klick-Handler in eb-quiz.js, damit alle data-quiz-open Links das Overlay öffnen */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-eb-quiz-open],[data-quiz-open]');
      if (!t || e.metaKey || e.ctrlKey || e.shiftKey || onQuizPage()) return;
      e.preventDefault();
      e.stopPropagation();
      var drawerClose = document.querySelector('.eb-drawer.is-open [data-eb-close-nav]');
      if (drawerClose) drawerClose.click();
      openQuiz(t.getAttribute('data-quiz-preset') || '');
    }, true);
    ov.querySelector('[data-eb-quiz-close]').addEventListener('click', closeQuiz);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !ov.hidden) closeQuiz();
      if (e.key === 'Tab' && !ov.hidden) { /* Fokus im Dialog halten: Schließen-Knopf und iframe */
        var x = ov.querySelector('[data-eb-quiz-close]');
        if (document.activeElement !== x && document.activeElement !== frame) { e.preventDefault(); x.focus(); }
      }
    });
    /* Das Quiz im iframe kann sich selbst schließen: parent.postMessage('eb-quiz-close') */
    window.addEventListener('message', function (e) { if (e.origin === location.origin && e.data === 'eb-quiz-close') closeQuiz(); });
  }

  /* ---------- Land/Währung: Liste schließt bei Klick daneben ---------- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-eb-cur][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-eb-cur][open]').forEach(function (d) { d.removeAttribute('open'); d.querySelector('summary').focus(); });
  });

  /* ---------- Zwei-Schritt-Formulare (Kündigungs- und Widerrufsbutton) ---------- */
  document.querySelectorAll('[data-two-step]').forEach(function (f) {
    var s1 = f.querySelector('[data-s1]'), s2 = f.querySelector('[data-s2]');
    if (!s1 || !s2) return;
    var sum = f.querySelector('[data-summary]');
    f.querySelector('[data-next]').addEventListener('click', function () {
      var fields = s1.querySelectorAll('input,select,textarea');
      for (var i = 0; i < fields.length; i++) { if (!fields[i].checkValidity()) { fields[i].reportValidity(); fields[i].focus(); return; } }
      if (sum) {
        sum.innerHTML = '';
        fields.forEach(function (el) {
          if (el.type === 'hidden' || !el.value) return;
          var lab = el.closest('label'), name = lab ? (lab.querySelector('span') || lab).textContent.trim() : el.name;
          var dt = document.createElement('dt'); dt.textContent = name;
          var dd = document.createElement('dd'); dd.textContent = el.tagName === 'SELECT' ? el.options[el.selectedIndex].text : el.value;
          sum.appendChild(dt); sum.appendChild(dd);
        });
      }
      s1.hidden = true; s2.hidden = false;
      var h = s2.querySelector('[tabindex="-1"]') || s2.querySelector('button'); if (h) h.focus();
    });
    var back = f.querySelector('[data-back]');
    if (back) back.addEventListener('click', function () { s2.hidden = true; s1.hidden = false; var first = s1.querySelector('input,select'); if (first) first.focus(); });
    f.addEventListener('submit', function (e) {
      if (s2.hidden) { e.preventDefault(); f.querySelector('[data-next]').click(); return; } /* Enter im ersten Schritt sendet nie direkt */
      var b = s2.querySelector('button[type="submit"]'); if (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); }
    });
  });
})();
